export class KmlToGeoJson {

    removeSpace = /\s*/g;
    trimSpace = /^\s*|\s*$/g;
    splitSpace = /\s+/;

    serializer = new XMLSerializer();

    gj = this.fc();
    // styleindex keeps track of hashed styles in order to match features
    styleIndex: any = []; styleByHash: any = [];
    // stylemapindex keeps track of style maps to expose in properties
    styleMapIndex: any = [];
    // atomic geospatial types supported by KML - MultiGeometry is
    // handled separately
    geotypes = ['Polygon', 'LineString', 'Point', 'Track', 'gx:Track'];

    placemarks: any;
    styles: any;
    styleMaps: any;

    geoms: any = [];
    coordTimes: any = []


    // generate a short, numeric hash of a string
    okhash(x: any) {
        if (!x || !x.length) return 0;
        for (var i = 0, h = 0; i < x.length; i++) {
            h = ((h << 5) - h) + x.charCodeAt(i) | 0;
        }
        return h;
    }

    // all Y children of X
    get(x: any, y: any) { return x.getElementsByTagName(y); }
    attr(x: any, y: any) { return x.getAttribute(y); }
    attrf(x: any, y: any) { return parseFloat(this.attr(x, y)); }

    // one Y child of X, if any, otherwise null
    get1(x: any, y: any) { var n = this.get(x, y); return n.length ? n[0] : null; }
    // https://developer.mozilla.org/en-US/docs/Web/API/Node.normalize
    norm(el: any) { if (el.normalize) { el.normalize(); } return el; }
    // cast array x into numbers
    numarray(x: any) {
        for (var j = 0, o = []; j < x.length; j++) { o[j] = parseFloat(x[j]); }
        return o;
    }
    // get the content of a text node, if any
    nodeVal(x: any) {
        if (x) { this.norm(x); }
        return (x && x.textContent) || '';
    }
    // get the contents of multiple text nodes, if present
    getMulti(x: any, ys: any) {
        let o = [], n, k;
        for (k = 0; k < ys.length; k++) {
            n = this.get1(x, ys[k]);
            if (n) o[ys[k]] = this.nodeVal(n);
        }
        return o;
    }
    // add properties of Y to X, overwriting if present in both
    extend(x: any, y: any) { for (var k in y) x[k] = y[k]; }
    // get one coordinate from a coordinate array, if any
    coord1(v: any) { return this.numarray(v.replace(this.removeSpace, '').split(',')); }
    // get all coordinates from a coordinate array as [[],[]]
    coord(v: any) {
        let coords = v.replace(this.trimSpace, '').split(this.splitSpace),
            o = [];
        for (var i = 0; i < coords.length; i++) {
            o.push(this.coord1(coords[i]));
        }
        return o;
    }
    coordPair(x: any) {
        var ll = [this.attrf(x, 'lon'), this.attrf(x, 'lat')],
            ele = this.get1(x, 'ele'),
            // handle namespaced attribute in browser
            heartRate = this.get1(x, 'gpxtpx:hr') || this.get1(x, 'hr'),
            time = this.get1(x, 'time'),
            e;
        if (ele) {
            e = parseFloat(this.nodeVal(ele));
            if (!isNaN(e)) {
                ll.push(e);
            }
        }
        return {
            coordinates: ll,
            time: time ? this.nodeVal(time) : null,
            heartRate: heartRate ? parseFloat(this.nodeVal(heartRate)) : null
        };
    }

    // create a new feature collection parent object
    fc() {
        return {
            type: 'FeatureCollection',
            features: []
        };
    }
    xml2str(str: any) {
        // IE9 will create a new XMLSerializer but it'll crash immediately.
        // This line is ignored because we don't run coverage tests in IE9
        /* istanbul ignore next */
        if (str.xml !== undefined) return str.xml;
        return this.serializer.serializeToString(str);
    }
    kmlColor(v: any) {
        let color, opacity = 0;
        v = v || '';
        if (v.substr(0, 1) === '#') { v = v.substr(1); }
        if (v.length === 6 || v.length === 3) { color = v; }
        if (v.length === 8) {
            opacity = parseInt(v.substr(0, 2), 16) / 255;
            color = '#' + v.substr(6, 2) +
                v.substr(4, 2) +
                v.substr(2, 2);
        }
        return [color, isNaN(opacity) ? undefined : opacity];
    }
    gxCoord(v: any) { return this.numarray(v.split(' ')); }
    gxCoords(root: any) {
        var elems = this.get(root, 'coord'), coords = [], times = [];
        if (elems.length === 0) elems = this.get(root, 'gx:coord');
        for (var i = 0; i < elems.length; i++) coords.push(this.gxCoord(this.nodeVal(elems[i])));
        var timeElems = this.get(root, 'when');
        for (var j = 0; j < timeElems.length; j++) times.push(this.nodeVal(timeElems[j]));
        return {
            coords: coords,
            times: times
        };
    }

    getGeometry(root: any): any {
        var geomNode, geomNodes, i, j, k;
        if (this.get1(root, 'MultiGeometry')) { return this.getGeometry(this.get1(root, 'MultiGeometry')); }
        if (this.get1(root, 'MultiTrack')) { return this.getGeometry(this.get1(root, 'MultiTrack')); }
        if (this.get1(root, 'gx:MultiTrack')) { return this.getGeometry(this.get1(root, 'gx:MultiTrack')); }
        for (i = 0; i < this.geotypes.length; i++) {
            geomNodes = this.get(root, this.geotypes[i]);
            if (geomNodes) {
                for (j = 0; j < geomNodes.length; j++) {
                    geomNode = geomNodes[j];
                    if (this.geotypes[i] === 'Point') {
                        this.geoms.push({
                            type: 'Point',
                            coordinates: this.coord1(this.nodeVal(this.get1(geomNode, 'coordinates')))
                        });
                    } else if (this.geotypes[i] === 'LineString') {
                        this.geoms.push({
                            type: 'LineString',
                            coordinates: this.coord(this.nodeVal(this.get1(geomNode, 'coordinates')))
                        });
                    } else if (this.geotypes[i] === 'Polygon') {
                        var rings = this.get(geomNode, 'LinearRing'),
                            coords = [];
                        for (k = 0; k < rings.length; k++) {
                            coords.push(this.coord(this.nodeVal(this.get1(rings[k], 'coordinates'))));
                        }
                        this.geoms.push({
                            type: 'Polygon',
                            coordinates: coords
                        });
                    } else if (this.geotypes[i] === 'Track' ||
                        this.geotypes[i] === 'gx:Track') {
                        var track = this.gxCoords(geomNode);
                        this.geoms.push({
                            type: 'LineString',
                            coordinates: track.coords
                        });
                        if (track.times.length) this.coordTimes.push(track.times);
                    }
                }
            }
        }
        return {
            geoms: this.geoms,
            coordTimes: this.coordTimes
        }
    }

    kml(doc: any) {
        // all root placemarks in the file
        this.placemarks = this.get(doc, 'Placemark');
        this.styles = this.get(doc, 'Style');
        this.styleMaps = this.get(doc, 'StyleMap');
        for (let k = 0; k < this.styles.length; k++) {
            let hash = this.okhash(this.xml2str(this.styles[k])).toString(16);
            this.styleIndex['#' + this.attr(this.styles[k], 'id')] = hash;
            this.styleByHash[hash] = this.styles[k];
        }
        for (let l = 0; l < this.styleMaps.length; l++) {
            this.styleIndex['#' + this.attr(this.styleMaps[l], 'id')] =
                this.okhash(this.xml2str(this.styleMaps[l])).toString(16);
            let pairs = this.get(this.styleMaps[l], 'Pair');
            let pairsMap: any = [];
            for (var m = 0; m < pairs.length; m++) {
                pairsMap[this.nodeVal(this.get1(pairs[m], 'key'))] =
                    this.nodeVal(this.get1(pairs[m], 'styleUrl'));
            }
            this.styleMapIndex['#' + this.attr(this.styleMaps[l], 'id')] = pairsMap;
        }
        for (var j = 0; j < this.placemarks.length; j++) {
            this.gj.features = this.gj.features.concat(this.getPlacemark(this.placemarks[j]));
        }
        return this.gj;
    }

    getPlacemark(root: any): any {
        const properties: any = [];
        let geomsAndTimes = this.getGeometry(root), i,
            name = this.nodeVal(this.get1(root, 'name')),
            address = this.nodeVal(this.get1(root, 'address')),
            styleUrl = this.nodeVal(this.get1(root, 'styleUrl')),
            description = this.nodeVal(this.get1(root, 'description')),
            timeSpan = this.get1(root, 'TimeSpan'),
            timeStamp = this.get1(root, 'TimeStamp'),
            extendedData = this.get1(root, 'ExtendedData'),
            lineStyle = this.get1(root, 'LineStyle'),
            polyStyle = this.get1(root, 'PolyStyle'),
            visibility = this.get1(root, 'visibility');

        if (!geomsAndTimes.geoms.length) return [];
        if (name) properties.name = name;
        if (address) properties.address = address;
        if (styleUrl) {
            if (styleUrl[0] !== '#') {
                styleUrl = '#' + styleUrl;
            }
            properties.styleUrl = styleUrl;
            if (this.styleIndex[styleUrl]) {
                properties.styleHash = this.styleIndex[styleUrl];
            }
            if (this.styleMapIndex[styleUrl]) {
                properties.styleMapHash = this.styleMapIndex[styleUrl];
                properties.styleHash = this.styleIndex[this.styleMapIndex[styleUrl].normal];
            }
            // Try to populate the lineStyle or polyStyle since we got the style hash
            var style = this.styleByHash[properties.styleHash];
            if (style) {
                if (!lineStyle) lineStyle = this.get1(style, 'LineStyle');
                if (!polyStyle) polyStyle = this.get1(style, 'PolyStyle');
                var iconStyle = this.get1(style, 'IconStyle');
                if (iconStyle) {
                    var icon = this.get1(iconStyle, 'Icon');
                    if (icon) {
                        var href = this.nodeVal(this.get1(icon, 'href'));
                        if (href) properties.icon = href;
                    }
                }
            }
        }
        if (description) properties.description = description;
        if (timeSpan) {
            var begin = this.nodeVal(this.get1(timeSpan, 'begin'));
            var end = this.nodeVal(this.get1(timeSpan, 'end'));
            properties.timespan = { begin: begin, end: end };
        }
        if (timeStamp) {
            properties.timestamp = this.nodeVal(this.get1(timeStamp, 'when'));
        }
        if (lineStyle) {
            var linestyles = this.kmlColor(this.nodeVal(this.get1(lineStyle, 'color'))),
                color = linestyles[0],
                opacity = linestyles[1],
                width = parseFloat(this.nodeVal(this.get1(lineStyle, 'width')));
            if (color) properties.stroke = color;
            if (!isNaN(opacity)) properties['stroke-opacity'] = opacity;
            if (!isNaN(width)) properties['stroke-width'] = width;
        }
        if (polyStyle) {
            var polystyles = this.kmlColor(this.nodeVal(this.get1(polyStyle, 'color'))),
                pcolor = polystyles[0],
                popacity = polystyles[1],
                fill = this.nodeVal(this.get1(polyStyle, 'fill')),
                outline = this.nodeVal(this.get1(polyStyle, 'outline'));
            if (pcolor) properties.fill = pcolor;
            if (!isNaN(popacity)) properties['fill-opacity'] = popacity;
            if (fill) properties['fill-opacity'] = fill === '1' ? properties['fill-opacity'] || 1 : 0;
            if (outline) properties['stroke-opacity'] = outline === '1' ? properties['stroke-opacity'] || 1 : 0;
        }
        if (extendedData) {
            var datas = this.get(extendedData, 'Data'),
                simpleDatas = this.get(extendedData, 'SimpleData');

            for (i = 0; i < datas.length; i++) {
                properties[datas[i].getAttribute('name')] = this.nodeVal(this.get1(datas[i], 'value'));
            }
            for (i = 0; i < simpleDatas.length; i++) {
                properties[simpleDatas[i].getAttribute('name')] = this.nodeVal(simpleDatas[i]);
            }
        }
        if (visibility) {
            properties.visibility = this.nodeVal(visibility);
        }
        if (geomsAndTimes.coordTimes.length) {
            properties.coordTimes = (geomsAndTimes.coordTimes.length === 1) ?
                geomsAndTimes.coordTimes[0] : geomsAndTimes.coordTimes;
        }
        let feature: any = {
            type: 'Feature',
            geometry: (geomsAndTimes.geoms.length === 1) ? geomsAndTimes.geoms[0] : {
                type: 'GeometryCollection',
                geometries: geomsAndTimes.geoms
            },
            properties: properties
        };
        if (this.attr(root, 'id')) feature.id = this.attr(root, 'id');
        return feature;
    }

    initializeArray(arr: any, size: any) {
        for (var h = 0; h < size; h++) {
            arr.push(null);
        }
        return arr;
    }
    getPoints(node: any, pointname: any) {
        let pts = this.get(node, pointname),
            line = [],
            times = [],
            heartRates = [],
            l = pts.length;
        if (l < 2) return {};  // Invalid line in GeoJSON
        for (var i = 0; i < l; i++) {
            let c = this.coordPair(pts[i]);
            line.push(c.coordinates);
            if (c.time) times.push(c.time);
            if (c.heartRate || heartRates.length) {
                if (!heartRates.length) this.initializeArray(heartRates, i);
                heartRates.push(c.heartRate || null);
            }
        }
        return {
            line: line,
            times: times,
            heartRates: heartRates
        };
    }

    getTrack(node: any) {
        let segments = this.get(node, 'trkseg'),
            track = [],
            times = [],
            heartRates = [];
        let line: any;
        for (var i = 0; i < segments.length; i++) {
            line = this.getPoints(segments[i], 'trkpt');
            if (line) {
                if (line.line) track.push(line.line);
                if (line.times && line.times.length) times.push(line.times);
                if (heartRates.length || (line.heartRates && line.heartRates.length)) {
                    if (!heartRates.length) {
                        for (var s = 0; s < i; s++) {
                            heartRates.push(this.initializeArray([], track[s].length));
                        }
                    }
                    if (line.heartRates && line.heartRates.length) {
                        heartRates.push(line.heartRates);
                    } else {
                        heartRates.push(this.initializeArray([], line.line.length || 0));
                    }
                }
            }
        }
        if (track.length === 0) return;
        var properties = this.getProperties(node);
        this.extend(properties, this.getLineStyle(this.get1(node, 'extensions')));
        if (times.length) properties.coordTimes = track.length === 1 ? times[0] : times;
        if (heartRates.length) properties.heartRates = track.length === 1 ? heartRates[0] : heartRates;
        return {
            type: 'Feature',
            properties: properties,
            geometry: {
                type: track.length === 1 ? 'LineString' : 'MultiLineString',
                coordinates: track.length === 1 ? track[0] : track
            }
        }
    }

    getRoute(node: any) {
        var line = this.getPoints(node, 'rtept');
        if (!line.line) return;
        var prop = this.getProperties(node);
        this.extend(prop, this.getLineStyle(this.get1(node, 'extensions')));
        var routeObj = {
            type: 'Feature',
            properties: prop,
            geometry: {
                type: 'LineString',
                coordinates: line.line
            }
        };
        return routeObj;
    }

    getPoint(node: any) {
        var prop = this.getProperties(node);
        this.extend(prop, this.getMulti(node, ['sym']));
        return {
            type: 'Feature',
            properties: prop,
            geometry: {
                type: 'Point',
                coordinates: this.coordPair(node).coordinates
            }
        };
    }

    getLineStyle(extensions: any) {
        let style: any;
        if (extensions) {
            var lineStyle = this.get1(extensions, 'line');
            if (lineStyle) {
                var color = this.nodeVal(this.get1(lineStyle, 'color')),
                    opacity = parseFloat(this.nodeVal(this.get1(lineStyle, 'opacity'))),
                    width = parseFloat(this.nodeVal(this.get1(lineStyle, 'width')));
                if (color) style.stroke = color;
                if (!isNaN(opacity)) style['stroke-opacity'] = opacity;
                // GPX width is in mm, convert to px with 96 px per inch
                if (!isNaN(width)) style['stroke-width'] = width * 96 / 25.4;
            }
        }
        return style;
    }

    getProperties(node: any) {
        let prop: any = this.getMulti(node, ['name', 'cmt', 'desc', 'type', 'time', 'keywords']),
            links: any = this.get(node, 'link');
        if (links.length) prop.links = [];
        for (var i = 0, link; i < links.length; i++) {
            link = { href: this.attr(links[i], 'href') };
            this.extend(link, this.getMulti(links[i], ['text', 'type']));
            prop.links.push(link);
        }
        return prop;
    }

    gpx(doc: any) {
        let i,
            tracks: any = this.get(doc, 'trk'),
            routes = this.get(doc, 'rte'),
            waypoints = this.get(doc, 'wpt'),
            // a feature collection
            gj: any = this.fc();
        let feature: any = [];
        for (i = 0; i < tracks.length; i++) {
            feature = this.getTrack(tracks[i]);
            if (feature) gj.features.push(feature);
        }
        for (i = 0; i < routes.length; i++) {
            feature = this.getRoute(routes[i]);
            if (feature) gj.features.push(feature);
        }
        for (i = 0; i < waypoints.length; i++) {
            gj.features.push(this.getPoint(waypoints[i]));
        }
    }
}

